angular.
module("dx.webapp.client", [
	"dx.webapp.api",
	"dx.webapp.clientVersion",
	"dx.webapp.datetimeinput",

	"dx.ui.components.dialog",
	"dx.ui.utils",
]);
